module.exports = "/static/assets/2f2173bcc10a837bd6732df4ce60e7cf.png";